/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-21 09:28:47
 * @LastEditTime: 2019-08-22 14:17:01
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
{
  path: '/',
  name: '',
  redirect:`/index`,
},
{
  path: '/index',
  name: 'index',
  component: () =>
    import('../view/index')
},
{
  path: '/register',
  name: 'register',
  component: () =>
    import('../view/register')
},
// {
//     path: '/login',
//     name: 'login',
//     redirect:`/login/language`,
// },
{
  path: '/login',
  name: 'login',
  component: () =>
    import('../view/login')
},
// {
//     path: '/download',
//     name: 'download',
//     redirect:`/download/language`,
// },
{
  path: '/download',
  name: 'download',
  component: () =>
    import('../view/download')
},
{
  path: '/newYearGifts',
  name: 'newYearGifts',
  component: () =>
    import('../view/newYearGifts')
},
{
  path: '/task',
  name: 'task',
  component: () =>
    import('../view/task') // 任务中心
},
{
  path: '/rank',
  name: 'rank',
  component: () =>
    import('../view/rank') // 返佣排行
},
{
  path: '/lottery',
  name: 'lottery',
  component: () =>
    import('../view/lottery') // 盲盒活动
},
{
  path: "/Halloween",
  name: "Halloween",
  component: () =>
    import("../view/Halloween")//万圣节活动
},
  {
    path: '/thirdParty',
    name: 'thirdParty',
    component: () => import('../view/thirdParty')
  },
{
  path: "/countersign",
  name: "countersign",
  component: () =>
    import("../view/countersign")
}, {
  path: '/rule',
  name: "rule",
  component: () =>
    import("../view/rules")
}, {
  path: "/windPople",
  name: "windPople",
  component: () =>
    import("../view/winprize")

},
{
  path: "/college",//学院
  name: "college",
  component: () =>
    import("../view/college/index.vue")
},
{
  path: "/news",
  name: "news",
  component: () =>
    import("../view/college/news")
},
{
  path: "/study",
  name: "study",
  component: () =>
    import("../view/college/study")
},
{
  path: "/dataPage",
  name: "dataPage",
  component: () =>
    import("../view/college/dataPage")
},
{
  path: "/college_detail",
  name: "college_detail",
  component: () =>
    import("../view/college/details")
},
{
  path: '/worldcup',
  name: 'worldcup',
  component: () =>
    import("../view/worldcup")
},
{
  path: '/purchase',
  name: 'purchase',
  component: () => import('../view/purchase')//一元购
},
{
  path: '/prizeHistory',
  name: '/prizeHistory',
  component: () => import('../view/purchase/historylist.vue')//一元购历史记录
},
{
  path: '/previous',
  name: '/previous',
  component: () => import('../view/purchase/previousRecords.vue')
},//一元购往期揭晓
{
  path: '/lamps',
  name: '/lamps',
  component: () => import('../view/purchase/lamps.vue')
},
{
  path: '/prizeDetail',
  name: '/prizeDetail',
  component: () => import('../view/purchase/Productdetails.vue')
},
{
  path: '/purchaseRule',
  name: '/purchaseRule',
  component: () => import('../view/purchase/rule.vue')
},
{
  path: '/worldcuprule',
  name: 'worldcuprule',
  component: () => import("../view/worldcuprule.vue")
},
{
    path:'/contractCompetition',
    name:'contractCompetition',
    component:()=>import('@/view/contractCompetition/index.vue')
},
  {
    path: '/activity',
    name: 'activity',
    component: () =>import('../view/activityCenter')
  },
{
  path:'/errorPage',
  name:'errorPage',
  component:()=>import('../view/404.vue')
},
{
  path: '/downloadMore',
  name: 'downloadMore',
  component: () => import("../view/downloadMore.vue")
}
]
export default new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js